module.exports = __webpack_public_path__ + "static/media/warningRecollected.a4f948da.svg";